<template>
  <rect
    x="0.5"
    y="0.5"
    width="39"
    height="39"
    rx="3.5"
    fill="white"
    stroke="#EBEEF5"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21 13C21 12.4477 20.5523 12 20 12C19.4477 12 19 12.4477 19 13V20.5858L16.7071 18.2929C16.3166 17.9024 15.6834 17.9024 15.2929 18.2929C14.9024 18.6834 14.9024 19.3166 15.2929 19.7071L19.2929 23.7071C19.6834 24.0976 20.3166 24.0976 20.7071 23.7071L24.7071 19.7071C25.0976 19.3166 25.0976 18.6834 24.7071 18.2929C24.3166 17.9024 23.6834 17.9024 23.2929 18.2929L21 20.5858V13ZM14 26C12.8954 26 12 26.8954 12 28H28C28 26.8954 27.1046 26 26 26H14Z"
    fill="#868D9C"
  />
</template>
